import { createSelector } from 'reselect';

// Config
import {
  getConfigFeaturesSelector,
  isBasketOrderTotalAlwaysVisibleFeatureActive,
} from '@redux/reducers/config/configSelector';
import {
  getConfirmationIsClickCollectOrderSelector,
  getConfirmationIsMultiBatchSelector,
  getConfirmationOrderAmountsSelector,
  getConfirmationOrderDeliveriesSelector,
} from '@redux/reducers/confirmation/orderConfirmationSelector';
import {
  getApplyRewardsApiCallActiveSelector,
  getOrderFormAmountsSelector,
  getOrderFormIsClickCollectOrderSelector,
  getOrderFormIsGiftReceiptOrderSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import featureConstants from '@constants/featureConstants';
import { FeatureFlagType } from 'types/FeatureFlag.types';

const orderTotalsOrderFormState = createSelector(
  [
    getOrderFormAmountsSelector,
    getOrderFormIsGiftReceiptOrderSelector,
    getOrderFormIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    isBasketOrderTotalAlwaysVisibleFeatureActive,
    getConfigFeaturesSelector,
  ],
  (
    amounts,
    isGiftReceiptOrder,
    isClickCollectOrder,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    features,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    basketOrderTotalAlwaysVisibleImpressionId:
      features?.find((f: FeatureFlagType) => f.id === featureConstants.BASKET_ORDER_TOTAL_ALWAYS_VISIBLE)
        ?.impressionId ?? '',
    isGiftReceiptOrder,
    isClickCollectOrder,
  }),
);

const orderTotalsConfirmationPagePropsState = createSelector(
  [
    getConfirmationOrderAmountsSelector,
    getConfirmationIsMultiBatchSelector,
    getConfirmationOrderDeliveriesSelector,
    getConfirmationIsClickCollectOrderSelector,
    getApplyRewardsApiCallActiveSelector,
    isBasketOrderTotalAlwaysVisibleFeatureActive,
    getConfigFeaturesSelector,
  ],
  (
    amounts,
    isMultiBatch,
    deliveries,
    isClickCollectOrder,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    features,
  ) => ({
    amounts,
    applyRewardsApiCallActive,
    basketOrderTotalAlwaysVisibleFeatureActive,
    basketOrderTotalAlwaysVisibleImpressionId:
      features?.find((f: FeatureFlagType) => f.id === featureConstants.BASKET_ORDER_TOTAL_ALWAYS_VISIBLE)
        ?.impressionId ?? '',
    isGiftReceiptOrder: !isMultiBatch && deliveries?.some((delivery) => delivery.isGiftReceiptOrder),
    isClickCollectOrder,
  }),
);

export { orderTotalsConfirmationPagePropsState, orderTotalsOrderFormState };
